import type {AiTextMorphResponse} from '@PosterWhiteboard/poster/poster.types';
import {getPosterObjectFromPosterBackendObject} from '@PosterWhiteboard/poster/poster-backend';
import type {PosterObjectBackend} from '@PosterWhiteboard/poster/poster-backend.types';

export const morphTextItemsForAiPrompt = async (
  itemKeyToTextMapping: Record<string, string>,
  prompt: string,
  promptFilters: Record<string, string> = {}
): Promise<AiTextMorphResponse> => {
  return window.PMW.readLocal('posterdesignmorph/generateTextForAiTextMorph', {
    mapping: itemKeyToTextMapping,
    prompt,
    promptFilters,
  }) as Promise<AiTextMorphResponse>;
};

export const morphPosterForAiPrompt = async (hashedId: string, prompt: string, promptFilters: Record<string, string> = {}, includeImages = false): Promise<PosterObjectBackend> => {
  const params = {
    posterHashId: hashedId,
    prompt,
    filter: promptFilters,
    includeImages: includeImages ? '1' : '0',
  };

  const pollingKey = (await window.PMW.readLocal('posterdesignmorph/morphPosterContent', params)) as {pollingKey: string};
  return window.PMW.pollingAjaxCallAsync(
    async (): Promise<void> => {},
    async (): Promise<PosterObjectBackend> => {
      return window.PMW.readLocal('posterdesignmorph/checkMorphPosterStatus', pollingKey);
    }
  ) as Promise<PosterObjectBackend>;
};

export const morphPoster = async (hashedId: string, prompt: string, promptFilters: Record<string, string> = {}, includeImages: boolean): Promise<void> => {
  if (!window.posterEditor?.whiteboard) {
    return;
  }

  const posterBackendObject = await morphPosterForAiPrompt(hashedId, prompt, promptFilters, includeImages);
  const posterObject = getPosterObjectFromPosterBackendObject(posterBackendObject);

  //CodeReviewTaimur: Why using replacePoster instead of updateFromObject?
  return window.posterEditor.whiteboard.replacePoster(posterObject);
};
